module.exports = __webpack_public_path__ + "img/checkout.650bba6d.png";